import React from "react"
import { useTranslation } from "react-i18next"

export default function PPMatchingStatusBanner({ variant, selectedShop, shopsWithMatches, onShopChange, onOpenFilters }) {
    const [t] = useTranslation()

    if (variant === "no_customer") {
        return (
            <output className="pp-matching-status-banner mb-3">
                <div className="d-flex align-items-start">
                    <i className="fas fa-user me-3 pp-matching-status-banner__icon" />
                    <div>
                        <div className="pp-matching-status-banner__title">{t("matching.no_customer_title")}</div>
                        <p className="mb-0 pp-matching-status-banner__text">{t("matching.no_customer_hint")}</p>
                    </div>
                </div>
            </output>
        )
    }

    if (variant === "no_shops") {
        return (
            <output className="pp-matching-status-banner mb-3">
                <div className="d-flex align-items-start">
                    <i className="fas fa-inbox pp-matching-status-banner__icon me-3" />
                    <div>
                        <div className="pp-matching-status-banner__title">{t("matching.no_shops_title")}</div>
                        <p className="mb-0 pp-matching-status-banner__text">{t("matching.no_shops_hint")}</p>
                    </div>
                </div>
            </output>
        )
    }

    if (variant === "empty_queue") {
        const shopName = selectedShop?.label?.split(" (")[0] ?? "—"
        const otherShops = (shopsWithMatches ?? []).filter((s) => s.id !== selectedShop?.value)

        return (
            <output className="pp-matching-status-banner mb-3">
                <div className="d-flex align-items-start">
                    <i className="fas fa-check pp-matching-status-banner__icon me-3" />
                    <div className="flex-grow-1">
                        <div className="pp-matching-status-banner__title">
                            {t("matching.empty_queue_for_shop", { shop: shopName })}
                        </div>
                        <p className="mb-2 pp-matching-status-banner__text">{t("matching.empty_queue_hint")}</p>
                        {(otherShops.length > 0 || onOpenFilters) && (
                            <div className="d-flex flex-wrap align-items-center">
                                {otherShops.length > 0 && (
                                    <span className="small text-muted me-2 mb-1">{t("matching.other_shops_with_matches")}</span>
                                )}
                                {otherShops.map((shop) => (
                                    <button
                                        key={shop.id}
                                        type="button"
                                        className="btn btn-outline-secondary btn-sm me-2 mb-1"
                                        onClick={() => onShopChange(shop.id)}
                                    >
                                        {shop.name} {shop.lang.toUpperCase()} ({shop.remainingMatches})
                                    </button>
                                ))}
                                <button type="button" className="btn btn-link btn-sm p-0 mb-1" onClick={onOpenFilters}>
                                    {t("matching.open_filters")}
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </output>
        )
    }

    return null
}
